<p *ngIf="alertType !== 'portfolio'">Set Alert Triggers</p>
<p *ngIf="alertType === 'portfolio'">Set Alert Trigger</p>

<div class="alerts-group">
  <div class="alerts-group-cont">
    <div class="alerts-group-main" *ngIf="triggers?.length">
      <div
        class="alerts-group-item"
        *ngFor="let trigger of triggers; index as index; last as last"
      >
        <div class="subalert-main">
          <div class="subalert-threshold">
            <mat-form-field class="field-subalert type">
              <mat-label>Choose Score</mat-label>
              <mat-select
                #selectorTriggerScore
                [(ngModel)]="trigger.score_type"
                (selectionChange)="onScoreChange($event, index)"
                required
              >
                <mat-option
                  *ngFor="let score of scoreTypes"
                  [value]="score.value"
                  [disabled]="
                    layout === 'explainable_digest' &&
                    score.value === 'sentiment'
                  "
                  >{{ score.label }}</mat-option
                >
              </mat-select>
            </mat-form-field>

            <mat-form-field class="field-subalert setting">
              <mat-label></mat-label>
              <mat-select
                #selectorTriggerThresholdSetting
                [(ngModel)]="trigger.threshold_setting"
                required
              >
                <ng-container *ngIf="!trigger.isDeltaAlert">
                  <mat-option value="cross_above">&#8805;</mat-option>
                  <mat-option value="cross_below">&#8804;</mat-option>
                  <mat-option
                    *ngFor="let setting of thresholdSettingTypes"
                    [value]="setting.value"
                    >{{ setting.label }}</mat-option
                  >
                </ng-container>
                <ng-container *ngIf="trigger.isDeltaAlert">
                  <mat-option value=">=">&#8805;</mat-option>
                  <mat-option value="<=">&#8804;</mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>

            <mat-form-field
              class="field-subalert value"
              *ngIf="trigger.score_type !== 'sentiment'"
            >
              <mat-label>Value...</mat-label>
              <input
                #inputTriggerThreshold
                type="number"
                maxlength="2"
                min="0"
                max="10"
                required
                matInput
                [(ngModel)]="trigger.threshold"
                (change)="
                  trigger.threshold < 0
                    ? (trigger.threshold = 0)
                    : trigger.threshold;
                  trigger.threshold > 10
                    ? (trigger.threshold = 0)
                    : trigger.threshold
                "
                name="threshold"
              />
              <mat-error>Please enter a value between 0 and 10</mat-error>
            </mat-form-field>

            <mat-form-field
              class="field-subalert value"
              *ngIf="trigger.score_type === 'sentiment'"
            >
              <mat-label>Value...</mat-label>
              <input
                #inputTriggerThreshold
                type="number"
                maxlength="3"
                min="0"
                max="100"
                required
                matInput
                [(ngModel)]="trigger.threshold"
                (change)="
                  trigger.threshold < 0
                    ? (trigger.threshold = 0)
                    : trigger.threshold;
                  trigger.threshold > 100
                    ? (trigger.threshold = 0)
                    : trigger.threshold
                "
                name="threshold"
              />
              <mat-error>Please enter a value between 0 and 100</mat-error>
            </mat-form-field>

            <div
              class="btndel"
              (click)="delTrigger(index)"
              *ngIf="triggers.length > 1"
            >
              <mat-icon>remove_circle</mat-icon>
            </div>
          </div>

          <div class="subalert-delta-line">
            <mat-slide-toggle
              class="delta-alert-toggle"
              [checked]="trigger.isDeltaAlert"
              (change)="onDeltaSlideToggle($event.checked, trigger, index)"
              [disabled]="!trigger.score_type"
            ></mat-slide-toggle>

            <span class="delta-alert-header">Associate a Delta Alert</span>
            <mat-icon
              matTooltip="Delta Alert notifies when the score changes by a set amount, based on the threshold value defined above"
              >info</mat-icon
            >
          </div>
          <app-alerts-setup-delta
            [trigger]="trigger"
            [selectedDeltaPeriod]="selectedDeltaPeriod"
            [deltaPeriods]="deltaPeriods"
          >
          </app-alerts-setup-delta>
        </div>
      </div>
    </div>

    <div
      class="btnflex group"
      *ngIf="alertType !== 'portfolio' && triggers?.length"
    >
      <button mat-button (click)="addTrigger()">
        <mat-icon>library_add</mat-icon>
        <span>TRIGGER</span>
      </button>
    </div>
  </div>
</div>
